import $ from 'jquery'
import { trace } from 'rytm-helpers'

const onVideoPause = (e) => {
  // trace("# video pause", e.target)
  const video = e.target
  const wrapper = video.closest(".video-wrapper")
  const wrapper2 = video.closest(".modvideo-main")
  if (wrapper) {
    wrapper.classList.remove("playing")
  }
  if (wrapper2) {
    wrapper2.classList.remove("media-playing")
  }
  video.removeEventListener('pause', onVideoPause)
  video.removeEventListener('ended', onVideoEnded)
  video.controls = false
}
const onVideoEnded = (e) => {
  const video = e.target
  video.currentTime = 0
}


const onVideoControlClick = (e) => {
  e.preventDefault()
  const wrapper = e.currentTarget.closest(".video-wrapper")
  const wrapper2 = e.currentTarget.closest(".modvideo-main")
  const video = wrapper.querySelector("video")
  if (wrapper) {
    wrapper.classList.add("playing")
  }
  if (wrapper2) {
    wrapper2.classList.add("media-playing")
  }
  video.addEventListener('pause', onVideoPause)
  video.addEventListener('ended', onVideoEnded)
  video.controls = true
  video.play()
}


export const initGloVideo = () => {
  $('body').on('click', '.video-control', onVideoControlClick)
}